// طبقة الوصول لعروض الأسعار - كلها عبر الباك اند
// (artika-backend/routes/proposalRoutes.js)، بدون Firestore مباشرة.
// الصور وحدها ترتفع لـStorage من الفرونت (editor/images.js).

import { apiFetch, API_BASE } from "../utils/apiClient";

async function request(path, options = {}) {
  const res = await apiFetch(`${API_BASE}${path}`, options);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || `HTTP ${res.status}`);
  return body;
}

const jsonBody = (method, data) => ({
  method,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(data),
});

// الباك اند يقبل هذي الحقول فقط (الباقي يثبّته السيرفر). coverBrandOffset
// (مكان شعار الغلاف) ينحفظ من المدير بس
export const toPayload = ({ recipientName, artworks, price, coverBrandOffset = 0, project }) => ({
  recipientName,
  artworks,
  price,
  coverBrandOffset,
  project,
});

export const listProposals = () => request("/proposals");
export const fetchProposal = (id) => request(`/proposals/${encodeURIComponent(id)}`);
export const createProposal = (data) => request("/proposals", jsonBody("POST", toPayload(data)));
export const updateProposal = (id, data) =>
  request(`/proposals/${encodeURIComponent(id)}`, jsonBody("PUT", toPayload(data)));
export const deleteProposal = (id) => request(`/proposals/${encodeURIComponent(id)}`, { method: "DELETE" });

// 📐 فاتورة مشروع: إنشاء/تحديث عرضها بعد كل حفظ (راجع fromInvoice.js)
export const syncProposalFromInvoice = (body) => request("/proposals/from-invoice", jsonBody("POST", body));

// اعتماد فاتورة العرض + بيانات واجهة إضافة الطلب ({ orderHandoff })
export const approveProposal = (id) => request(`/proposals/${encodeURIComponent(id)}/approve`, { method: "POST" });

// 📋 "اعتماد التسعيرة": نفس الفاتورة تتحوّل لفاتورة مشروع ({ invoiceId })
export const convertQuote = (id) => request(`/proposals/${encodeURIComponent(id)}/convert-quote`, { method: "POST" });
